{
  "el": {
    "issue_list": {
      "actions": {
        "add_units": "Ακίνητα",
        "change_responsible": "Αλλαγή υπευθύνου",
        "check": "Έλεγχος",
        "create_issue_lists": "Δημιουργία λίστας παρατηρήσεων | Δημιουργία λιστών παρατηρήσεων",
        "delete": "Διαγραφή",
        "delete_count": "Πρόκειται να διαγράψεις τις παρατηρήσεις για {count} ακίνητο. Θέλεις σίγουρα να συνεχίσεις; | Πρόκειται να διαγράψεις τις παρατηρήσεις για {count} ακίνητα. Θέλεις σίγουρα να συνεχίσεις;",
        "delete_issue_lists": "Διαγραφή παρατηρήσεων",
        "edit": "Επεξεργασία",
        "edit_issue_list": "Επεξεργασία τύπου λίστας παρατηρήσεων",
        "export": "Εξαγωγή",
        "generatePDF": "Δημιουργία PDF",
        "go_to_summary": "Μετάβαση στη σύνοψη",
        "new": "Παρατήρηση",
        "new_customer": "Αναφορά παρατήρησης",
        "new_issue_list": "Λίστα παρατηρήσεων",
        "selectAll": "Επιλογή και των {total} λιστών",
        "unSelectAll": "Εκκαθάριση επιλογής",
        "update": "Ενημέρωση"
      },
      "attributes": {
        "date": "Ημερομηνία έναρξης",
        "description": "Περιγραφή",
        "name": "Όνομα"
      },
      "labels": {
        "aftercare_conversations": "Συνομιλίες παρατηρήσεων",
        "aftercare_conversations_go_to_settings": "Μετάβαση στις ρυθμίσεις",
        "aftercare_conversations_not_enabled": "Οι συνομιλίες μέσα στις παρατηρήσεις δεν είναι ακόμη ενεργοποιημένες. Μπορείς να τις ενεργοποιήσεις στις ρυθμίσεις του οργανισμού σου.",
        "aftercare_conversations_toggle": "Ενεργοποίηση συνομιλιών μέσα στις παρατηρήσεις",
        "assign_list_failed": "Δεν μπορέσαμε να το αποθηκεύσουμε. Δοκίμασε ξανά.",
        "assign_list_field": "Λίστα",
        "assign_list_note": "{count} παρατήρηση θα προστεθεί στη λίστα που θα επιλέξεις. | {count} παρατηρήσεις θα προστεθούν στη λίστα που θα επιλέξεις.",
        "assign_list_placeholder": "Επίλεξε μια λίστα",
        "assign_to_list": "Ανάθεση σε λίστα",
        "completed_header": "{completed_count} από {issues_count} παρατηρήσεις ολοκληρώθηκαν",
        "customer": "Πελάτης",
        "date": "Ημερομηνία έναρξης (προαιρετικό)",
        "delete_explanation": "Όλες οι παρατηρήσεις, μαζί με τις εικόνες και τα έγγραφά τους, θα διαγραφούν οριστικά από την πλατφόρμα.",
        "description_title": "Πρόσθεσε μια περιγραφή",
        "deselect_all": "Αποεπιλογή όλων",
        "edit_multiple": "Επεξεργασία {count} λιστών παρατηρήσεων",
        "hide_count": "Κατάργηση δημοσίευσης παρατηρήσεων για 1 ακίνητο | Κατάργηση δημοσίευσης παρατηρήσεων για {count} ακίνητα",
        "hide_count_SUP": "Κατάργηση δημοσίευσης παρατηρήσεων",
        "issue_list": "Λίστα παρατηρήσεων",
        "issue_lists": "Παρατηρήσεις",
        "issue_lists_all_projects": "Παρατηρήσεις όλων των έργων",
        "issues_count": "Παρατηρήσεις",
        "no_issues_to_export": "Δεν υπάρχουν παρατηρήσεις για εξαγωγή",
        "no_lists_completed": "Καμία ολοκληρωμένη λίστα",
        "partners": "Συνεργάτες",
        "pdf_generated_successfully": "Το PDF δημιουργήθηκε με επιτυχία",
        "process_issues": "Ανάθεση {count} παρατήρησης | Ανάθεση {count} παρατηρήσεων",
        "project_units_total": "{project_name} έχει συνολικά {units_count_max} ακίνητα",
        "publish_now": "Δημοσίευση τώρα;",
        "published_count": "Δημοσίευση παρατηρήσεων για 1 ακίνητο | Δημοσίευση παρατηρήσεων για {count} ακίνητα",
        "published_count_SUP": "Δημοσίευση παρατηρήσεων",
        "save_explainer": "Να γίνουν οι (μελλοντικές) παρατηρήσεις ορατές στους πελάτες σου; Ή να αποθηκεύσεις τώρα και να δημοσιεύσεις αργότερα;",
        "selectOne": "Επίλεξε τουλάχιστον 1 λίστα",
        "select_all": "Επιλογή όλων",
        "selected": "{selected} επιλεγμένη λίστα. | {selected} επιλεγμένες λίστες",
        "status": "κατάσταση",
        "step_1_info": "Π.χ. προσωρινή ή οριστική παράδοση, παρατηρήσεις για την κουζίνα ή τα μπάνια,...",
        "step_1_title": "Τι τύπο λίστας παρατηρήσεων θέλεις να φτιάξεις;",
        "step_2_subtitle": "Επίλεξε το έργο σου για να συμπεριλάβεις όλα τα ακίνητα με μία κίνηση. Μπορείς πάντα να προσθέσεις κι άλλα ακίνητα αργότερα.",
        "step_2_title": "Για ποια ακίνητα θέλεις να καταγράψεις παρατηρήσεις;",
        "tab_issue_list_documents": "Έγγραφα",
        "tab_issue_list_issues": "Παρατηρήσεις",
        "tab_issue_list_issues_customer": "Παρατηρήσεις",
        "tab_issue_list_tickets": "Συνομιλίες",
        "tab_issues": "Όλες οι παρατηρήσεις",
        "tab_units": "Ακίνητα",
        "totalSelected": "Επιλέχθηκαν και οι {total} λίστες",
        "you_have_customer_issues": "Έχεις 1 μη επεξεργασμένη παρατήρηση πελάτη | Έχεις {number} μη επεξεργασμένες παρατηρήσεις πελατών"
      },
      "navigation": {
        "back_to_issue_lists": "Επιστροφή στις λίστες παρατηρήσεων"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Παρακολούθησε τις παρατηρήσεις που έχουν αναφερθεί",
            "title": "Εδώ θα εμφανίζονται όλες οι παρατηρήσεις σου"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Δημιούργησε παρατηρήσεις για τα ακίνητα που είναι συνδεδεμένα με τη λίστα",
            "title": "Δημιούργησε την πρώτη σου λίστα παρατηρήσεων"
          }
        },
        "partners": {
          "subtitle": "Θα ειδοποιηθείς όταν δημιουργηθούν νέες παρατηρήσεις",
          "title": "Δεν σου έχει ανατεθεί ακόμη καμία παρατήρηση"
        }
      },
      "validation": {
        "name_taken_locale": "Αυτό το όνομα χρησιμοποιείται ήδη σε αυτή τη γλώσσα",
        "need_name": "Το όνομα είναι υποχρεωτικό"
      }
    }
  }
}
